import {
    AddressDetailRow, AddressWrapper, MapWarpper
} from "./styles/compare.styled"
import { PremiseDetailProps } from "../types";
import ReactLoading from "react-loading";
import NumberFormat from 'react-number-format';
import { UsageAdjust } from "./UsageAdjust";
import { Button } from "@mui/material";
import { GetUsageEntry } from "./styles/usage.styled";

export const CompareAside = ({
    premiseDetail, premiseLoading, address,
    usages, handleShowSidebar, handleGetEstUsage,
    handleChangeUsage, sourceFrom, isEstMode
}: {
    premiseDetail: PremiseDetailProps|undefined,
    premiseLoading: boolean,
    address: string,
    usages: number[],
    handleShowSidebar: Function;
    handleGetEstUsage: Function;
    handleChangeUsage: Function;
    sourceFrom: string;
    isEstMode: boolean;
}) => {
    const { lot_size, bathrooms, bedrooms } = premiseDetail || {};
    
    return (
        <div>
            <AddressWrapper>
                <i />
                <div>
                    {
                        premiseLoading ? <ReactLoading type="bubbles" color="#bbb" width={36} height={36} /> :
                        <>
                            <b>{address}</b>
                            <AddressDetailRow>
                                { lot_size && <span><NumberFormat value={lot_size} displayType={'text'} thousandSeparator={true} /> SqFt</span> }
                                { bedrooms && <span>{bedrooms} Bedrooms</span> }
                                { bathrooms && <span>{bathrooms} Bathrooms</span> }
                            </AddressDetailRow>
                        </>
                    }
                </div>
            </AddressWrapper>
            <MapWarpper>
                {
                    address &&
                    <iframe
                        width="100%"
                        height="100%"
                        style={{border:0}}
                        loading="lazy"
                        allowFullScreen
                        referrerPolicy="no-referrer-when-downgrade"
                        src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyCsreMGj8xStaCAs9V2HjMizheuJaVlII0&q=${encodeURIComponent(address)}&zoom=10`}>
                    </iframe>
                }
            </MapWarpper>
            <UsageAdjust
                usage={usages}
                disabled={false}
                handleChangeUsage={(usages: string[]) => handleChangeUsage(usages)}
                handleReset={() => handleGetEstUsage()}
                isEstMode={isEstMode}
                handleSwitchToEstMode={() => handleGetEstUsage()}
                sourceFrom={sourceFrom}
            />
            {
                isEstMode &&
                <GetUsageEntry>
                    <p>Retrieve real-time usage within minutes by allowing access.</p>
                    <Button
                        variant="contained"
                        onClick={() => handleShowSidebar()}
                    >
                        Get My Usage
                    </Button>
                </GetUsageEntry>
            }
        </div>
    )
}